import React, {useEffect, useState} from "react";

import {Box, Button, Typography} from "@mui/material";

import {useTranslation} from "react-i18next";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";

import alertBullet from "./img/alert_bullet.png";
import desktopUsers from "./img/desktop_users.png";

import {makeStyles} from "tss-react/mui";

import {sendGAEvent, sendGAPageView} from "ui-common/GoogleAnalytics";

import {MOUTH_OPEN_CHECK_ENABLED, SHOW_DOUBLE_CROSSHAIR} from "../../components/mugshot/FaceMeasurer/MugShotConfig"

import {
  isManualMeasurementEnabled,
  brightcoveAccountId,
  brightcovePlayerId
} from "../../AppSettings";

import preScanVideoPoster from "./img/scanPoster3.png"
import warningIcon from "./img/warning-triangle.svg"
import ovalOverlay from "../../components/mugshot/FaceMeasurer/img/gradient_frame_transparent.png";

import crossHair from "../../components/mugshot/FaceMeasurer/img/crosshair.png";
import doubleCrossHairOrig from "../../components/mugshot/FaceMeasurer/img/double_crosshair.png";


import BrightcovePlayer from "../../BrightcovePlayer";

const VideoBox = () => {
  const[videoLoaded, setVideoLoaded] = useState(false);
  const { t } = useTranslation("pages.MaskSelectorTool.RetryFaceScan");

  const brightcoveRetryVideoUrlId = t("brightcoveRetryVideoUrlId");
  const useStyles = makeStyles()(() => ({
    videoContainer: {
      position: "relative",
      width: "289px",
      height: "289px",
      flexShrink: 0,

      "@media only screen and (min-width: 640px)": {
        width: "328px",
        height: "328px",
      },
    },

    videoOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
    },
  }));
  const {classes: localClasses} = useStyles();

  return (
      <Box className={localClasses.videoContainer}>

        <BrightcovePlayer
            accountId={brightcoveAccountId}
            playerId={brightcovePlayerId}
            videoId={brightcoveRetryVideoUrlId}
            poster={preScanVideoPoster}
            loop={true}
            autoplay={true}
            onLoadedCallBack={() => {setVideoLoaded(true) } }
            controls={false}
        />

          { videoLoaded && <img src={SHOW_DOUBLE_CROSSHAIR ? doubleCrossHairOrig : crossHair } alt="" className={localClasses.videoOverlay}/> }
          <img src={videoLoaded ? ovalOverlay : preScanVideoPoster} alt="" className={localClasses.videoOverlay}/>
      </Box>
  )
}


const ErrorBullet = ({ message }) => {
  const useStyles = makeStyles()(() => ({
    container: {
      display: "flex",
      alignItems: "center",
      marginBottom: "30px"
    },

    imgBox: {
      width: "24px",
      height: "24px",
      marginRight: "15px"
    }
  }));

  const {classes: localClasses} = useStyles();
  const {classes} = MaskSelectorToolStyles();

  return (
      <Box className={localClasses.container}>
        <img className={localClasses.imgBox} src={alertBullet} alt="" />
        <Typography className={`${classes.bulletText} ${classes.noOutline}`} tabIndex="0" aria-label={message}>{message}</Typography>
      </Box>
  );
};

const RetryFaceScan = ({ errors, onRetry, onManual, setBackButtonOverride }) => {
  const { t } = useTranslation("pages.MaskSelectorTool.RetryFaceScan");

  const desktopUserNote = t("desktopUserNote");
  const desktopNoteDetail = t("desktopNoteDetail");
  const retryButton = t("retryButton");
  const hintHeader = t("hintHeader");
  const glassesError = t("glassesError");
  const mouthError = t("mouthError");
  const eyesError = t("eyesError");
  const timeoutError = t("timeoutError");
  const manualMeasurementLink = t("manualMeasurementLink");
  const warningIconAltText = t("warningIconAltText");

  const {classes} = MaskSelectorToolStyles();

  useEffect(() => {
    sendGAPageView("RetryFaceScan");
  }, []);
  
  useEffect(() => {  
    if (errors.mouthOpen) {
      sendGAEvent("FaceScan", "error", "mouthOpen");
    }
        
    if (errors.glassesOn) {
      sendGAEvent("FaceScan", "error", "glassesOn");
    }
          
    if (errors.eyesClosed) {
      sendGAEvent("FaceScan", "error", "eyesClosed");
    }
            
    if (errors.timeout) {
      sendGAEvent("FaceScan", "error", "timeout");
    }
  }, [errors]);

  useEffect(() => {
      if (setBackButtonOverride !== undefined) {
          setBackButtonOverride(true)
      }
  }, [setBackButtonOverride])

  const useStyles = makeStyles()(() => ({
    exitChoiceBox: {
      marginTop: "40px",
      width: "100%",
      textAlign: "center"
    },

    footerBox: {
      display: "none",

      "@media only screen and (min-width: 640px)": {
        display: "block",
        marginTop: "100px",
        marginBottom: "48px",
      }
    },

    desktopImgBox: {
      float: "left",
      marginLeft: 20,
      marginRight: 20,
    },

    footerTextBox: {
      marginTop: 20,
    },

    manualMeasurementButton: {
      ...classes.res_standaloneLink,
      marginTop: "16px"
    },

    errIcon: {
      display: "none",

      "@media only screen and (min-width: 640px)": {
        ...classes.noOutline,
        display: "block",
        width: "150px",
        height: "150px",
      }
    },

    gridContainer: {
      display: "grid",
      alignItems: "center",
      justifyItems: "center",
      marginTop: "16px",
      marginBottom: "24px",

      "@media only screen and (min-width: 640px)": {
        gridTemplateColumns: "min-content 1fr",
      }
    },

    gridItemErrMsg: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",

      "@media only screen and (min-width: 640px)": {
        gridColumn: "2"
      }
    },

    gridItemVideo: {
      "@media only screen and (min-width: 640px)": {
        gridColumn: "1",
        gridRow: "1 / span 2",
      }
    }
  }));

  const {classes: localClasses} = useStyles();

  return (
    <>
      <Box className={localClasses.gridContainer}>
        <Box className={localClasses.gridItemErrMsg}>
          <img className={localClasses.errIcon} alt={warningIconAltText} src={warningIcon} tabIndex="0" />
          <Typography className={` ${classes.res_heading3} ${classes.boldText} ${classes.noOutline}`} tabIndex="0" aria-label={hintHeader} sx={{marginBottom: "24px"}}>
            {hintHeader}
          </Typography>

          <Box>
            <>
              {errors?.eyesClosed && <ErrorBullet message={eyesError}/>}
              {errors?.glassesOn && <ErrorBullet message={glassesError}/>}
              {errors?.mouthOpen && MOUTH_OPEN_CHECK_ENABLED && <ErrorBullet message={mouthError}/>}
              {errors?.timeout && <ErrorBullet message={timeoutError}/>}
            </>
          </Box>
        </Box>

        <Box className={localClasses.gridItemVideo}>
          <VideoBox />
        </Box>

        <Box className={localClasses.exitChoiceBox}>
          <Button
              disableRipple
              variant="contained"
              color="secondary"
              onClick={onRetry}
          >
            {retryButton}
          </Button>
          { isManualMeasurementEnabled() && (
              <Button
                  disableRipple
                  color="primary"
                  onClick={onManual}
                  className={localClasses.manualMeasurementButton}
                  variant="text"
              >
                {manualMeasurementLink}
              </Button>
          )}
        </Box>
      </Box>
      <Box className={localClasses.footerBox}>
        <hr className={classes.retryHR}/>

        <Box>
          <Box className={localClasses.desktopImgBox}>
            <img src={desktopUsers} alt="" />
          </Box>
          <Box className={localClasses.footerTextBox}>
            <Typography className={`${classes.res_heading6} ${classes.noOutline}`} tabIndex="0" aria-label={desktopUserNote}>{desktopUserNote}</Typography>
            <Typography className={classes.noOutline} tabIndex="0" aria-label={desktopNoteDetail}>{desktopNoteDetail}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RetryFaceScan;
